<template>
  <div class="input-select d-block" v-on-clickaway="closeSelect">
    <label
      v-if="label"
      @click="closeSelect">{{ $t(label) }} <span v-if="rules.required" class="warning-color">*</span></label>
    <div
      :class="{required: shouldShowError, disabled: disabled}"
      @click="openListOnClick"
      class="input-like"
      tabindex="0"
      @focus="openListOnFocus">
      <span v-if="cmpTextValue === ''"></span>
      <span v-else class="cut-text">{{ cmpTextValue }}</span>
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <div v-show="isListOpened" class="options-list">
      <ul class="select-list">
        <template>
          <li
            style="padding-left: 25px"
            tabIndex="-1"
            v-for="(option, palletIndex) in filteredList"
            :key="`option-${palletIndex}`"
            :ref="`${randomSelectId}-${palletIndex}-opt`"
            :class="{active : value && Object.values(value).includes(option[valueKey])}"
            class="flex m-b-10">
            <span style="flex: 1;">{{ option.name }}</span>
            <InputText
              style="flex: 1"
              class="m-r-10"
              :value="exchange[palletIndex].value"
              @input="setExchange(option.id, $event)"
            />
          </li>
        </template>
        <li  class="m-b-10 no-exchange-pallet">
          <div class="button light d-inline-block" @click.stop="selectEmpty()"><span class="button-text">{{ $t('LBL_NO_EXCHANGE_PALLETS')}}</span></div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style lang="scss">
.no-exchange-pallet {
  justify-content: center;
  font-weight: 500;
  .button {
    text-align: center;
    text-transform: uppercase
  }
}
</style>
<script>
/* eslint-disable */

import {directive as onClickaway} from 'vue-clickaway';
import CountryFlag from 'vue-country-flag';
import Checkbox from '@/components/elements/inputs/checkbox';
import rules from "@/mixins/rules";
import Button from "@/components/elements/buttons/button.vue";
import i18n from "@/i18n";
import InputText from '@/components/elements/inputs/text.vue';
import {mapGetters} from "vuex";

const defaultExchange = [
  {id: '1_1', value: '', name: '1/1 ' + i18n.t('Pallet')},
  {id: '1_2', value: '', name: '1/2 ' + i18n.t('Pallet')},
  {id: '1_4', value: '', name: '1/4   ' + i18n.t('Pallet')},
]

export default {
  name: 'palletExchange',
  mixins: [rules],
  components: {
    InputText,
    Button,
    CountryFlag, Checkbox,
  },
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    valueKey: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: [String, Number],
    },
    colli: {
      type: [String, Number],
    },
    selectedPalletId: {
      type: [String, Number],
    },
    label: {
      type: String,
      default: 'Choose Country',
    },
    value: {
      type: [String, Number, Array, Object]
    },
    goodsType: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exchange: defaultExchange,
      doExchange: false,
      indexItem: 0,
      indexContinent: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
    };
  },
  computed: {
    filteredList() {
      return this.exchange
    },
    cmpTextValue() {
      if (this.value) {
        const exchangePallets = this.value.filter(item => item.value > 0);
        if (exchangePallets) {
          return exchangePallets.map(item => `${item.value} x ${item.name}`).join(', ')
        }
      }
      return this.$t('LBL_NO_EXCHANGE_PALLETS')
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
    hasExchange() {
      let hasExchange = false
      this.exchange.forEach((item, index) => {
        if (this.exchange[index].value > 0) {
          hasExchange = true
        }
      });
      return hasExchange
    },
    ...mapGetters([
      'get_user',
      'get_pallet_types',
    ]),
  },
  watch: {
    colli: {
      handler(newColli) {
        this.handleAutoPalletExchange();
      }
    },
    selectedPalletId: {
      handler(newPalleteType) {
        this.handleAutoPalletExchange();
      }
    },
    goodsType: {
      handler(newGoodsType, oldGoodsType) {
        console.log('GoodsType changed:', oldGoodsType, '->', newGoodsType);
        if (newGoodsType === 3 && oldGoodsType !== 3) {
          console.log('Switching TO pallet, colli:', this.colli, 'palletId:', this.selectedPalletId);
          // Use a longer delay for goods type changes
          setTimeout(() => {
            this.handleAutoPalletExchange();
          }, 200);
        } else if (oldGoodsType === 3 && newGoodsType !== 3) {
          console.log('Switching FROM pallet - clearing exchange');
          this.clearPalletExchange();
        }
      }
    },
    disabled(newVal) {
      if (newVal) {
        // When field is disabled, enforce no exchange and emit events
        this.clearPalletExchange();
      }
    }
  },
  methods: {
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    openListOnClick() {
      if (this.disabled) return;
      if (this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      });
    },
    openListOnFocus() {
      if (this.disabled) return;
      this.isListOpened = true;
      this.$nextTick(() => {
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      });
    },
    setExchange(optionId, $event) {
      const item = this.exchange.find(item => item.id === optionId);
      const index = this.exchange.indexOf(item);
      this.exchange[index].value = $event && Number.isInteger(parseInt($event)) ? $event : '';

      if (this.hasExchange) {
        this.doExchange = true;
        this.$emit('input', this.exchange);
        this.$emit('change', this.exchange);
      } else {
        this.emitEmpty()
      }
    },
    selectEmpty() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.emitEmpty()
    },
    emitEmpty() {
      this.resetValue()
      this.$emit('input', null);
      this.$emit('change', null);
      this.doExchange = false;
      this.search = '';
    },
    resetValue() {
      this.exchange.forEach((item, index) => {
        this.exchange[index].value = ''
      });
    },
    clearPalletExchange() {
      this.resetValue();
      this.emitEmpty();
    },
    handleAutoPalletExchange() {
      // Add proper null checks
      if (!this.get_user?.auto_pallet_exchange || !this.colli || !this.selectedPalletId) {
        console.log('Auto exchange conditions not met:', {
          autoEnabled: this.get_user?.auto_pallet_exchange,
          colli: this.colli,
          selectedPalletId: this.selectedPalletId
        });
        return;
      }

      // Check if pallet types are loaded
      if (!this.get_pallet_types || !Array.isArray(this.get_pallet_types) || this.get_pallet_types.length === 0) {
        console.log('Pallet types not loaded yet, will retry when available');
        // Retry after a short delay when pallet types might be loaded
        setTimeout(() => {
          this.handleAutoPalletExchange();
        }, 500);
        return;
      }

      // Reset all exchange values first
      this.resetValue();

      // Determine which pallet type to use based on selectedPalletId value
      let targetExchangeId = null;

      const pallete = this.get_pallet_types.find(item => parseInt(item.id) === parseInt(this.selectedPalletId));

      // Add null check for pallete
      if (!pallete) {
        console.log('Pallet type not found for ID:', this.selectedPalletId);
        return;
      }

      // Map pallet types: 18 = Half pallet, 19 = Quarter pallet, 16, 17 = Full pallet
      if (parseInt(pallete.type) === 19) {
        // Quarter pallet - 60cm x 40cm
        targetExchangeId = '1_4';
      } else if (parseInt(pallete.type) === 18) {
        // Half pallet - 80cm x 60cm
        targetExchangeId = '1_2';
      } else if ([16, 17].includes(parseInt(pallete.type))) {
        // Full pallet (Euro pallet, Pallet unspecified, Pallet 120x80cm)
        targetExchangeId = '1_1';
      } else {
        console.log('Unknown pallet type:', pallete.type);
        return;
      }

      // Set the exchange value for the determined pallet type
      if (targetExchangeId) {
        this.setExchange(targetExchangeId, this.colli.toString());
      }
    }
  },
  mounted() {
    if (this.value) {
      this.value.forEach(item => {
        this.setExchange(item.id, item.value)
      })
    }
    // Handle auto pallet exchange on mount if conditions are met
    this.handleAutoPalletExchange();
    // If the field is disabled at mount time, enforce no exchange immediately
    if (this.disabled) {
      this.clearPalletExchange();
    }
  },
  destroyed() {
    this.resetValue()
  }
}
</script>
